import AAVE from "src/assets/images/tokens/aave.svg";
import ADA from "src/assets/images/tokens/ADA.png";
import BTCB from "src/assets/images/tokens/BTCB.png";
import busd from "src/assets/images/tokens/busd.png";
import dai from "src/assets/images/tokens/dai.svg";
import DOT from "src/assets/images/tokens/DOT.png";
import usdc from "src/assets/images/tokens/usdc.svg";
import usdt from "src/assets/images/tokens/usdt.svg";
import BNB from "src/assets/images/tokens/BNB.png";
import XVS from "src/assets/images/tokens/xvs.svg";
import ETH from "src/assets/images/tokens/ETH.png";
import XRP from "src/assets/images/tokens/xrp.png";
import CAKE from "src/assets/images/tokens/cake.svg";
import DOGE from "src/assets/images/tokens/DOGE.png";

const BscMainnetTokens = {
  "0x1af3f329e8be154074d8769d1ffa4ee058b1dbc3": {
    symbol: "DAI",
    image: dai,
    decimal: 18,
    loanToValue: 0.77,
    lt: 0.8,
    liquidationBonus: 0.05,
    reserveFactor: 0.15,
    utilizationOptimal: 0.8,
    slope1: 0.04,
    slope2: 0.75,
    baseInterestRate: 0,
    borrowingEnabled: true,
  },
  "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d": {
    symbol: "USDC",
    image: usdc,
    decimal: 6,
    loanToValue: 0.8,
    lt: 0.85,
    liquidationBonus: 0.05,
    reserveFactor: 0.15,
    utilizationOptimal: 0.9,
    slope1: 0.04,
    slope2: 0.6,
    baseInterestRate: 0,
    borrowingEnabled: true,
  },
  "0x55d398326f99059ff775485246999027b3197955": {
    symbol: "USDT",
    image: usdt,
    decimal: 18,
    loanToValue: 0.75,
    lt: 0.8,
    liquidationBonus: 0.05,
    reserveFactor: 0.15,
    utilizationOptimal: 0.9,
    slope1: 0.04,
    slope2: 0.6,
    baseInterestRate: 0,
    borrowingEnabled: true,
  },
  "0x2170ed0880ac9a755fd29b2688956bd959f933f8": {
    symbol: "ETH",
    image: ETH,
    decimal: 18,
    loanToValue: 0.825,
    lt: 0.85,
    liquidationBonus: 0.05,
    reserveFactor: 0.15,
    utilizationOptimal: 0.65,
    slope1: 0.08,
    slope2: 1,
    baseInterestRate: 0,
    borrowingEnabled: true,
  },
  "0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c": {
    symbol: "BNB",
    image: BNB,
    decimal: 18,
    loanToValue: 0.75,
    lt: 0.8,
    liquidationBonus: 0.05,
    reserveFactor: 0.15,
    utilizationOptimal: 0.65,
    slope1: 0.1,
    slope2: 1,
    baseInterestRate: 0,
    borrowingEnabled: true,
  },
  "0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c": {
    symbol: "BTCB",
    image: BTCB,
    decimal: 18,
    loanToValue: 0.7,
    lt: 0.75,
    liquidationBonus: 0.09,
    reserveFactor: 0.2,
    utilizationOptimal: 0.65,
    slope1: 0.07,
    slope2: 1,
    baseInterestRate: 0,
    borrowingEnabled: true,
  },
  "0xe9e7cea3dedca5984780bafc599bd69add087d56": {
    symbol: "BUSD",
    image: busd,
    decimal: 18,
    loanToValue: 0.75,
    lt: 0.8,
    liquidationBonus: 0.05,
    reserveFactor: 0.15,
    utilizationOptimal: 0.8,
    slope1: 0.04,
    slope2: 1,
    baseInterestRate: 0,
    borrowingEnabled: true,
  },
  "0xfb6115445bff7b52feb98650c87f44907e58f802": {
    symbol: "AAVE",
    image: AAVE,
    decimal: 18,
    loanToValue: 0.7,
    lt: 0.75,
    liquidationBonus: 0.05,
    reserveFactor: 0.15,
    utilizationOptimal: 0.65,
    slope1: 0.07,
    slope2: 1,
    baseInterestRate: 0,
    borrowingEnabled: true,
  },
  "0x3ee2200efb3400fabb9aacf31297cbdd1d435d47": {
    symbol: "ADA",
    image: ADA,
    decimal: 18,
    loanToValue: 0.7,
    lt: 0.75,
    liquidationBonus: 0.05,
    reserveFactor: 0.2,
    utilizationOptimal: 0.65,
    slope1: 0.08,
    slope2: 1,
    baseInterestRate: 0,
    borrowingEnabled: true,
  },
  "0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82": {
    symbol: "CAKE",
    image: CAKE,
    decimal: 18,
    loanToValue: 0.7,
    lt: 0.75,
    liquidationBonus: 0.05,
    reserveFactor: 0.2,
    utilizationOptimal: 0.65,
    slope1: 0.08,
    slope2: 1,
    baseInterestRate: 0,
    borrowingEnabled: true,
  },
  "0x1d2f0da169ceb9fc7b3144628db156f3f6c60dbe": {
    symbol: "XRP",
    image: XRP,
    decimal: 18,
    loanToValue: 0.7,
    lt: 0.75,
    liquidationBonus: 0.05,
    reserveFactor: 0.2,
    utilizationOptimal: 0.65,
    slope1: 0.08,
    slope2: 1,
    baseInterestRate: 0,
    borrowingEnabled: true,
  },
  "0xba2ae424d960c26247dd6c32edc70b295c744c43": {
    symbol: "DOGE",
    image: DOGE,
    decimal: 18,
    loanToValue: 0.55,
    lt: 0.6,
    liquidationBonus: 0.08,
    reserveFactor: 0.2,
    utilizationOptimal: 0.6,
    slope1: 0.8,
    slope2: 1.5,
    baseInterestRate: 0,
    borrowingEnabled: true,
  },
  "0x7083609fce4d1d8dc0c979aab8c869ea2c873402": {
    symbol: "DOT",
    image: DOT,
    decimal: 18,
    loanToValue: 0.7,
    lt: 0.75,
    liquidationBonus: 0.05,
    reserveFactor: 0.2,
    utilizationOptimal: 0.65,
    slope1: 0.08,
    slope2: 1,
    baseInterestRate: 0,
    borrowingEnabled: true,
  },
  "0xcf6bb5389c92bdda8a3747ddb454cb7a64626c63": {
    symbol: "XVS",
    image: XVS,
    decimal: 18,
    loanToValue: 0.6,
    lt: 0.65,
    liquidationBonus: 0.05,
    reserveFactor: 0.2,
    utilizationOptimal: 0.65,
    slope1: 0.07,
    slope2: 1,
    baseInterestRate: 0,
    borrowingEnabled: true,
  },
};

export default BscMainnetTokens;
